import type { IconProp } from '../icon'
import type { CopyToClipboardProps } from './copyToClipboard.types'

import Button from '../button'
import { vui } from '../core'
import { cs } from '../utils'
import { useCopyToClipboard } from './useCopyToClipboard'

const defaultIcon: IconProp = 'falCopy'

/**
 * A helper button component.
 *
 * Copies the provided text to clipboard.
 *
 * Copying is available only for a secure environment (https://), otherwise the button is disabled.
 *
 */
export const CopyToClipboard = vui<'button', CopyToClipboardProps>((props, ref) => {
  const {
    disabled,
    copyText,
    className,
    icon = defaultIcon,
    size = 'sm',
    variant = 'tertiary',
    intent = 'brand',
    ...rest
  } = props

  const { copy, isCopyDisabled } = useCopyToClipboard(copyText)

  return (
    <Button
      aria-label={`Copy to clipboard ${copyText}`}
      className={cs('vui-copy-to-clipboard', className)}
      disabled={disabled || isCopyDisabled}
      icon={icon}
      intent={intent}
      onClick={() => copy()}
      ref={ref}
      size={size}
      variant={variant}
      {...rest}
    />
  )
})

CopyToClipboard.displayName = 'CopyToClipboard'
export default CopyToClipboard
